import Body from "../components/layout/Body";
import FileList from "../components/FileList";
import FolderListingSidebar from "../components/layout/Sidebar/FolderListingSidebar";

const Dashboard = () => {
    return <>
        <Body mainElement={<FileList title="Tutti i file" />} sideBar={<FolderListingSidebar />} />
    </>;
}

export default Dashboard;
